import urlConstants from '@finsight/router';

export default urlConstants;
